import { scrollBarYClassName } from '@/utils/scrollBarClassName';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import ForceAuth from '../auth/ForceAuth';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import MadeByCtrlPlay from '@/components/ui/custom/MadeByCtrlPlay';
import Header from './Header';
import SidebarDesktop from './Sidebar/SidebarDesktop';
import SidebarMobile from './Sidebar/SidebarMobile';

type LayoutProps = PropsWithChildren & {
  className?: string;
  privated?: boolean;
};

export default function Layout(props: LayoutProps) {
  const { children, privated = true, className } = props;
  return (
    <ConditionalWrapper wrapper={<ForceAuth />} condition={privated}>
      <div className="flex w-screen h-screen bg-accent p-3 lg:pl-0">
        <SidebarMobile />
        <SidebarDesktop key="menu" />
        <div className="flex flex-col flex-1 overflow-x-hidden py-1 rounded-xl bg-base-200 h-full">
          <div
            className={twMerge(
              'relative flex flex-col grow gap-4 py-1 px-2 md:py-3 md:px-5 overflow-x-hidden',
              scrollBarYClassName,
              className,
            )}
          >
            <Header />

            {children}
          </div>
          <MadeByCtrlPlay />
        </div>
      </div>
    </ConditionalWrapper>
  );
}
